import React, { useState, useEffect } from 'react'
import "./header.css"
import { connect, useDispatch } from "react-redux"
import Select from "react-select";
import { Link, useLocation } from 'react-router-dom';
import { FiChevronDown, FiMenu } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { logout } from '../../../Redux/actions';
import { useSelector } from 'react-redux';
import { getProfile, getName, getCompany, getUserName } from '../../../Redux/selecters';
import Avatar from "../../Assets/Images/avatar.png"
import { clearCompanies, updateCompany, updateSelectedCompany } from '../../../Redux/actions/companiesAction';
import { saveLogin, setUserRole } from "../../../Redux/actions";
import userManagement from "../../../POS/services/userManagement";
import { invokeLogin } from "../../../POS/services/signalRService";
import { setCompanies } from "../../../Redux/actions/companiesAction";
import ApiService from '../../../INVENTORY/services/apiService';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LanguageSwitcher from './languageSwitcher';

const PMHeader = ({ Currency }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const location = useLocation();
    // Breadcrumb from the route: Lease/Management/Procurement/Approval -> Lease Management / Procurement / Approval
    const crumbs = (() => {
        const human = (x) => x.replace(/[_-]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2");
        const segs = location.pathname.split("/").filter(Boolean).filter((x) => !/^\d+$/.test(x));
        if (!segs.length) return ["Dashboard"];
        if (segs[0] === "Lease" && segs[1] === "Management") return ["Lease Management", ...segs.slice(2).map(human)];
        return segs.map(human);
    })();
    const fulname = useSelector(getName);
    const [userName, setUsername] = useState(fulname)
    const Name = useSelector(getUserName);
    const companies = useSelector(getCompany);
    const apiService = new ApiService();
    let navigate = useNavigate();
    const image = useSelector(getProfile);
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
        db: '',
        baseDb: ''
    });
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };
    const closeDropdown = () => {
        setIsDropdownOpen(false);
    };

    const [financialYear, setFinancialYear] = useState([]);
    const [activeFY, setActiveFY] = useState(null);
    const fyOptions = financialYear.map(fy => ({
        label: fy.name,
        value: fy,
        isDisabled: !fy.isActive, // ❌ disable inactive years
    }));
    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem("financialYear")) || [];

        setFinancialYear(financialYears);

        // 1️⃣ first priority: selected FY
        const savedFY = JSON.parse(localStorage.getItem("selectedFinancialYear"));

        if (savedFY) {
            setActiveFY({
                label: savedFY.name,
                value: savedFY,
            });
            return;
        }
        // 2️⃣ fallback: active FY
        const active = financialYears.find(fy => fy.isActive);
        if (active) {
            setActiveFY({
                label: active.name,
                value: active,
            });
        }
    }, []);


    const handleFYChange = (selected) => {
        setActiveFY(selected);

        // store selected financial year
        localStorage.setItem("selectedFinancialYear", JSON.stringify(selected.value));
    };
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest('.InvProfile')) {
                closeDropdown();
            }
        };
        document.addEventListener('click', handleOutsideClick);
        return () => document.removeEventListener('click', handleOutsideClick);
    }, []);
    useEffect(() => {
        const url = window.location.href;
        const regex = /_username=([^&]+)&_password=([^&]+)&_db=([^&]+)&_baseDb=([^&]+)/;
        const match = url?.match(regex);
        if (match) {
            handleLogin({
                username: match[1],
                password: match[2],
                db: match[3],
                baseDb: match[4]
            })
        }

    }, []);
    useEffect(() => {
        if (!userName) {
            dispatch(clearCompanies());
        }
    }, [userName]);
    const handleLogin = async (first) => {
        dispatch(logout());
        dispatch(clearCompanies());
        localStorage.clear();

        let token = localStorage.getItem("Token")
        if (!token) {
            let body = {
                email: credentials?.username || first?.username,
                password: credentials?.password || first?.password,
                basedb: credentials?.baseDb || first?.baseDb,
                supportdb: credentials?.db || first?.db
            };
            try {
                const response = await apiService.post("GET_ENCRYPT_TOKEN", body);

                if (response && response.status === 200) {
                    dispatch(saveLogin(response?.data))
                    const userRole = userManagement.getUserRole(response?.data?.data?.accessToken);
                    dispatch(setUserRole(userRole))
                    localStorage.setItem('Token', response?.data?.data?.accessToken)
                    localStorage.setItem('Refresh_Token', response?.data?.data?.refreshToken)
                    const userCompanies = response?.data?.data?.userCompanies;
                    dispatch(setCompanies(userCompanies));
                    localStorage.setItem('UserCompanies', JSON.stringify(userCompanies));
                    let selectedCompany = userCompanies.find((comp) => comp.dataDB === response?.data?.data?.dataDb)
                    const userId = userManagement.getUserId(response?.data?.data?.userCompanies);
                    if (userId) {
                        invokeLogin(userId);
                    }
                    if (selectedCompany) {
                        dispatch(updateSelectedCompany(selectedCompany));
                        setSelectedCompany({ label: selectedCompany?.companyName, value: selectedCompany });
                        localStorage.setItem('DataBase', selectedCompany?.dataDB);
                        let param = `?username=${response?.data?.data?.userName}&companyNo=${selectedCompany?.companyNo}`
                        const res = await apiService.getApiParamater("GET_PERMISSIONS", param);
                        // const permissions = res?.data?.data.filter((per) => per.moduleName === "Customers & Property Listing (Pro)");
                        const permissions = res?.data?.data?.filter(
                            (per) =>
                                per.moduleName === "Customers & Property Listing (Pro)" ||
                                per.moduleName === "Customers & Property Listing"
                        );
                        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
                        const finres = await apiService.get('GET_FINANCIAL_YEAR');
                        let years = finres?.data?.data
                        const active = years.find(fy => fy.isActive);
                        localStorage.setItem('financialYear', JSON.stringify(years));
                        localStorage.setItem("selectedFinancialYear", JSON.stringify(active));
                        setFinancialYear(years)
                        navigate("/")
                        window.location.reload();
                    } else {
                        toast.error("")
                    }

                } else if (response.status == false) {
                    localStorage.clear();
                    window.location.href = 'https://app.pro360erp.com/';
                }
            } catch (error) {
                console.log(error, "errrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr");
            }
        } else {
            window.location.href = "https://app.pro360erp.com";
        }

    };
    useEffect(() => {
        if (companies?.companies?.length) {

            let DB = localStorage.getItem('DataBase');
            let defaultCompany = companies?.companies.find((comp) => comp.dataDB === DB)
            setSelectedCompany({ label: defaultCompany?.companyName, value: defaultCompany });
            localStorage.setItem('DataBase', defaultCompany?.dataDB);
            dispatch(updateSelectedCompany(defaultCompany));
        }
    }, [companies?.companies, dispatch]);

    const handleDBChange = async (selectedOption) => {
        setSelectedCompany(selectedOption);
        dispatch(updateCompany(0, selectedOption.value));
        localStorage.setItem('DataBase', selectedOption?.value?.dataDB);
        let param = `?username=${Name}&companyNo=${selectedOption?.value?.companyNo}`

        const res = await apiService.getApiParamater("GET_PERMISSIONS", param);
        // const permissions = res?.data?.data.filter((per) => per.moduleName === "Customers & Property Listing (Pro)");
        const permissions = res?.data?.data?.filter(
            (per) =>
                per.moduleName === "Customers & Property Listing (Pro)" ||
                per.moduleName === "Customers & Property Listing"
        );
        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
        window.location.reload();
    };

    const handleOut = () => {
        dispatch(logout());
        dispatch(clearCompanies());
        localStorage.clear();
        window.location.href = 'https://app.pro360erp.com/';
    };

    return (
        <header className="invHead hd-bar">
            <button type="button" className="hd-menu" aria-label="Toggle menu" onClick={() => window.dispatchEvent(new Event("pm-toggle-sidebar"))}>
                <FiMenu size={18} />
            </button>
            <div className="hd-crumbs" aria-label="Breadcrumb">
                {crumbs.map((c, i) => (
                    <React.Fragment key={`${c}-${i}`}>
                        {i > 0 && <span aria-hidden="true">/</span>}
                        <span className={i === crumbs.length - 1 ? 'hd-crumb-last' : ''}>{c}</span>
                    </React.Fragment>
                ))}
            </div>
            <div className="hd-spacer" />
            <div className="hd-entity" title={selectedCompany?.label}>
                <span className="hd-entity-label">{t('header.entity', 'Entity')}</span>
                <span className="hd-entity-name">{selectedCompany?.label || '—'}</span>
                <FiChevronDown size={14} color="#6B6880" />
            </div>
            <LanguageSwitcher />
            <div className="InvProfile dropdown hd-user">
                <div onClick={toggleDropdown} className="hd-user-toggle">
                    <div aria-hidden="true" className="hd-avatar">{String(userName || 'U').trim().charAt(0).toUpperCase()}</div>
                    <span className="hd-user-name">{userName || 'No-User'}</span>
                </div>
                {isDropdownOpen && (
                    <div className="dropdown-content-stats pt-1">
                        <Link to="/admin/Setting/Profile" className="p-2">{t('common.settings')}</Link>
                        <Link onClick={handleOut} className="p-2">{t('common.logout')}</Link>
                    </div>
                )}
            </div>
        </header>

    )
}


const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(PMHeader);